// --------------------------------------------------------------
// Created On: 2024-10-15
// Author: KC Willard
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import Modal from "../../../components/Modal/Modal";
import ModalBody from "../../../components/ModalBody/ModalBody";
import DotLoader from "../../../components/DotLoader/DotLoader";

import styles from "./ProcessingOrderModal.module.scss";

// Modal displayed while order is processing.
export default function ProcessingOrderModal(props: Props): Component {
  return (
    <div data-test="processing-order-modal">
      <Modal
        show={props.showModal}
        onHide={() => {}}
        backdropClassName={`${styles.modal} ${styles.backdrop}`}
        style={{ zIndex: "var(--super-modal-z-index)" }}
        animation
        centered
      >
        <ModalBody>
          <div className="row justify-content-center">
            <div className="col text-center">
              <img className={`${styles.logo} m-2`} src="/logo.png" alt="Shop Cornell Pump" />
            </div>
          </div>
          <div className="row justify-content-center align-items-center  my-4">
            <DotLoader loading={true} className="justify-content-center align-items-center" isLarge></DotLoader>
          </div>
          <div className="row justify-content-center m-2">
            <span className={`${styles.messageText}`}>
              Processing order. Please don&apos;t refresh the page. You will be redirected when order is complete.
            </span>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

interface Props {
  showModal: boolean;
}
